import style from "./style.module.css";
import TestElement, {
  ITestChoice,
  QuestionFontSize,
} from "@/shared/components/candidate/scenes/TestElement/TestElement";
import { ILocalizedTestElement } from "@/modules/assessments/types/test.interface";
import { getResolvedElementText } from "../../utils/test-element-content.utils";

export interface IGroupedTestElementsContainer {
  currentAnswers: ITestChoice[];
  isTimedOutSection: boolean;
  groupHeaderText?: string;
  segment: ILocalizedTestElement[];
  handleChoiceSelect: (value: ITestChoice) => void;
}

export function GroupedTestElementsContainer({
  currentAnswers,
  isTimedOutSection,
  groupHeaderText,
  segment,
  handleChoiceSelect,
}: IGroupedTestElementsContainer) {
  return (
    <div className={style.groupedContainer}>
      {groupHeaderText && <p className={style.groupHeader}>{groupHeaderText}</p>}
      {segment.map((element) => {
        return (
          <div key={element.elementId} className={style.groupedTestItem}>
            <TestElement
              id={element.elementId}
              disableChoices={isTimedOutSection}
              choices={element.config.payload.choices}
              currentAnswer={currentAnswers.find((answer) => answer.elementId === element.elementId)?.choiceKey}
              questionType={element.config.type}
              question={getResolvedElementText(element)}
              questionNumber={element.questionNumber}
              questionFontSize={QuestionFontSize.large}
              onChoiceSelect={handleChoiceSelect}
            />
          </div>
        );
      })}
    </div>
  );
}
